import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from "redux-persist/lib/storage";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import thunk from 'redux-thunk';

import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import rootReducer from './rootReducer'; // giá trị trả về từ combineReducers

const encryptor = encryptTransform({
    secretKey: process.env.REACT_APP_SECRET_KEY,
    onError: function (error) {
        // Handle the error.
    }
})

const persistConfig = {
    key: 'cloudzone',
    storage: storage,
    stateReconciler: autoMergeLevel2, // Xem thêm tại mục "Quá trình merge"
    whitelist: ['login', 'user', 'agency', 'infoAdmin'],
    blacklist: ['adminMain', 'system', 'configSystem', 'notificationUser'],
    transforms: [encryptor],
};

const pReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
    pReducer,
    applyMiddleware(thunk)
);

// store.subscribe( () => {
//     console.log( store.getState() );
// });

export const persistor = persistStore(store);